import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const entityCardTechRadar: ExtensionDefinition =
  EntityCardBlueprint.make({
    name: 'tech-radar-card',
    params: {
      type: 'content',
      filter: {
        kind: 'Resource',
        'spec.type': 'tech-blip',
      },
      loader: async () =>
        import('./tech-radar-card').then(m => <m.TechRadarCard />),
    },
  });
